import UsersTemplate from '../../../components/Templates/Users/UsersTemplate';
/**
 * @page Users.tsx
 * @description admin page to list users.
 * @return { page }
 */
function Users() {
  return <UsersTemplate />;
}

export default Users;
